import {
  type PageEntity,
  apiClient,
  type AdditionalPaymentCategoryEntity
} from '@/libs/api'
import type { AdditionalPaymentCategoriesListRequestQuery } from '@/libs/api/types'

export type FetchAdditionalPaymentCategoriesListQuery = {
  tenantKey: string
  query?: AdditionalPaymentCategoriesListRequestQuery
}

export type FetchAdditionalPaymentCategoriesListResponse = {
  data: AdditionalPaymentCategoryEntity[]
  pagination: PageEntity | null
}

// 追加支払運賃項目一覧ページ用 一覧取得API（管理画面用 #4209: ADMIN は全拠点表示）
export const fetchAdditionalPaymentCategoriesList = async (
  { tenantKey, query }: FetchAdditionalPaymentCategoriesListQuery,
  signal?: AbortSignal
): Promise<FetchAdditionalPaymentCategoriesListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .additional_payment_categories.list.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
